import { Controller } from "@hotwired/stimulus"

// Where the trays live (#269). The server renders the jobs tray and the
// people tray below the board, once, with the ids their streams and caches
// key on. The sidebar supersedes them at every width: this moves the jobs tray
// into the Jobs mode and the people tray's add control into the People
// panel's footer, choosing the desktop or mobile host. One DOM copy, so no
// id is ever duplicated. A Turbo morph puts the server's order back; the
// morph handler re-hosts.
const DESKTOP = "(min-width: 1024px)"

export default class extends Controller {
  static targets = ["jobsHost", "jobsCreateHost", "peopleHost"]

  connect() {
    this.media = window.matchMedia(DESKTOP)
    this.onMediaChange = () => this.place()
    this.media.addEventListener("change", this.onMediaChange)
    this.place()
  }

  disconnect() {
    this.media?.removeEventListener("change", this.onMediaChange)
  }

  place() {
    const placement = this.media.matches ? "desktop" : "mobile"

    this.#host(
      "[data-plan-canvas-tasks-tray]",
      this.jobsHostTargets.find(host => host.dataset.canvasTrayHostPlacement === placement),
      this.element.querySelector("[data-canvas-tray-anchor='jobs']")
    )
    this.#host(
      "[data-canvas-tray-item='people-create']",
      this.peopleHostTargets.find(host => host.dataset.canvasTrayHostPlacement === placement),
      this.element.querySelector("[data-canvas-tray-anchor='people-create']")
    )
    // Runs after the jobs tray has been hosted, so this lifts the create
    // control back out of it and onto the panel's foot, where People's already
    // sits. Adding is then in one place in every mode.
    this.#host(
      "[data-canvas-tray-item='jobs-create']",
      this.jobsCreateHostTargets.find(host => host.dataset.canvasTrayHostPlacement === placement),
      this.element.querySelector("[data-canvas-tray-anchor='jobs-create']")
    )
  }

  #host(selector, host, anchor) {
    const items = Array.from(this.element.querySelectorAll(selector))
    // A missing anchor means the server no longer renders this item, for
    // example after create permission is removed. Resize keeps the anchors.
    if (!anchor) {
      items.forEach(item => item.remove())
      return
    }
    // A partial cable-region morph recreates the source while the sidebar's
    // hosted copy survives outside that region. Prefer the fresh anchored
    // source and discard stale copies before moving it into the active host.
    const source = anchor.nextElementSibling
    const item = source?.matches(selector) ? source : items[0]
    if (!item) return
    items.forEach(candidate => { if (candidate !== item) candidate.remove() })

    if (host) {
      if (item.parentElement !== host) host.appendChild(item)
    } else if (anchor) {
      if (item.previousElementSibling !== anchor) anchor.after(item)
    }
  }
}
